var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenlittle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.15 13.15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: #5b5757;\n      }"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.76,6.54h-.25c0,1.11-.45,2.11-1.17,2.83-.72.72-1.72,1.17-2.83,1.17s-2.1-.45-2.83-1.17c-.72-.72-1.17-1.72-1.17-2.83s.45-2.11,1.17-2.83c.73-.72,1.72-1.17,2.83-1.17s2.11.45,2.83,1.17c.73.73,1.17,1.72,1.17,2.83h.5c0-2.49-2.02-4.5-4.5-4.5S2.01,4.05,2.01,6.54s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5h-.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.53 6.57c0 1.65-0.67 3.13-1.75 4.21s-2.57 1.74-4.21 1.74-3.13-0.67-4.21-1.74c-1.08-1.08-1.74-2.57-1.75-4.21 0-1.65 0.67-3.13 1.75-4.21s2.56-1.74 4.21-1.74 3.13 0.67 4.21 1.74c1.08 1.08 1.75 2.57 1.75 4.21h0.62c0-3.63-2.94-6.57-6.57-6.57s-6.58 2.94-6.58 6.57 2.94 6.58 6.57 6.58 6.57-2.94 6.57-6.58h-0.62z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenlittle);
export default __webpack_public_path__ + "static/media/kitchenlittle.59865d102f9d08b159f90651939f58cb.svg";
export { ForwardRef as ReactComponent };